export default __webpack_public_path__ + "static/media/announcement_4@2x.784bdace.png";